import { readFileBytes } from './decode';

// PDF sahifalar sonini faqat brauzerda aniqlash (pdf.js). Tarmoqqa hech narsa yuborilmaydi:
// fayl baytlari to'g'ridan-to'g'ri beriladi, pdf.js va uning worker'i alohida chunk bo'lib
// faqat birinchi kerak bo'lganda yuklanadi. Worker asosiy oqimda ishlaydi (window.pdfjsWorker).
const cache = new WeakMap();

async function load(file) {
    const [pdfjs] = await Promise.all([
        import('pdfjs-dist/build/pdf'),
        import('pdfjs-dist/build/pdf.worker.entry'),
    ]);
    const data = new Uint8Array(await readFileBytes(file));
    const task = pdfjs.getDocument({
        data,
        isEvalSupported: false,
        disableAutoFetch: true,
        disableStream: true,
        disableRange: true,
        verbosity: 0,
    });
    const doc = await task.promise;
    const count = doc.numPages;
    doc.destroy();
    return count;
}

// Shifrlangan yoki buzilgan PDF'da reject qiladi
export function countPdfPages(file) {
    if (!file) return Promise.reject(new Error('PDF tanlanmagan'));
    if (!cache.has(file)) {
        cache.set(file, load(file).catch((error) => {
            cache.delete(file);
            throw error;
        }));
    }
    return cache.get(file);
}
